/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tr_11_QInputs */

const en_tut_tr_11_q = /** @type {(inputs: Tut_Tr_11_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The meeting reminder never appeared.`)
};

const id_tut_tr_11_q = /** @type {(inputs: Tut_Tr_11_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengingat rapat tidak muncul.`)
};

/**
* | output |
* | --- |
* | "The meeting reminder never appeared." |
*
* @param {Tut_Tr_11_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tr_11_q = /** @type {((inputs?: Tut_Tr_11_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tr_11_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tr_11_q(inputs)
	return en_tut_tr_11_q(inputs)
});